
import { Empty, Skeleton, Table, Tooltip, Switch } from 'antd'
import React, { useState } from 'react'
import moment from 'moment'

import { useToggleDocumentArchive, useDocumentGuides } from '../../hooks/userGuides';


const DocumentGuideList = (props) => {

    const sortDirections = ['ascend', 'descend', 'ascend'];
    const [pageSize, setPageSize] = useState(10);
    // const [filteredData, setFilteredData] = useState([]);

    const { showModal } = props;

    const { data: filteredData = [], isFetching } = useDocumentGuides();

    const toggleArchive = useToggleDocumentArchive();

    const onArchiveToggle = (record) => {
        return async (checked) => {
            await toggleArchive.mutateAsync({ uuid: record.uuid, archive: checked })
            .catch((err)=> {console.error("ERROR: ", err);}); // Feedback provided by mutate async
        }
    };

    const columns = [
        {
            title: "File Name",
            dataIndex: "filename",
            key: "1",
            showOnResponse: true,
            showOnDesktop: true,
            sortDirections: sortDirections,
            sorter: (a, b) => {
                return a.filename.localeCompare(b.filename);
            },
        },
        {
            title: "Module name",
            dataIndex: "targetModule",
            key: "2",
            showOnResponse: true,
            showOnDesktop: true,
            sortDirections: sortDirections,
            sorter: (a, b) => {
                return a.targetModule.localeCompare(b.targetModule);
            },
        },
        // {
        //     title: "Uploaded Date",
        //     dataIndex: "createdDate",
        //     key: "3",
        //     render: (text) => {
        //         return text != null ? moment(text).format("DD MMM YYYY") : "";
        //     },
        //     showOnResponse: true,
        //     showOnDesktop: true,
        //     sortDirections: sortDirections,
        //     defaultSortOrder: "descend",
        //     sorter: (a, b) => {
        //         return a.createdDate.localeCompare(b.createdDate);
        //     },
        // },
        {
            title: "Modified Date",
            dataIndex: "lastModified",
            key: "4",
            render: (text) => {
                return text != null ? moment(text).format("DD MMM YYYY") : "";
            },
            showOnResponse: true,
            showOnDesktop: true,
            sortDirections: sortDirections,
            defaultSortOrder: "descend",
            sorter: (a, b) => {
                return a.lastModified.localeCompare(b.lastModified);
            },
        },
        {
            title: "Archived",
            dataIndex: "archived",
            key: "archived-3b",
            showOnResponse: true,
            showOnDesktop: true,
            render: (_, record) => {
                
                const isArchived = !!record.archived;
                
                return (
                    <Tooltip title={isArchived ? "Un-archive guide" : "Archive guide"}>
                        <Switch
                            checkedChildren="Yes" unCheckedChildren="No"
                            style={{ marginLeft: "20px" }}
                            checked={isArchived}
                            onChange={onArchiveToggle(record)}
                        />
                    </Tooltip>
                );
            }
        },
        {
            title: "Actions",
            dataIndex: "actions",
            key: "actions-1",
            showOnResponse: true,
            showOnDesktop: true,
            render: (_, record) => {
                const isArchived = !!record.archived;
                return (
                    <>
                        <>
                            <a key={"a-" + record.id} onClick={() => showModal(record, "view")}>View</a>
                            <a key={"b-" + record.id} onClick={() => showModal(record, "edit")}>
                               <span style={{ paddingLeft: "20px" }}></span> Edit
                                </a>
                        </>
                    </>
                );
            },
        },
    ]

    const onRowChange = (row) => {
        setPageSize(row.pageSize);
    };
    

    return (
        <>
            <div className="space"></div>
            <Table
                dataSource={isFetching ? [] : filteredData}
                locale={{
                    emptyText: isFetching ? <Skeleton active={true} /> : <Empty />,
                }}
                columns={columns}
                rowKey={(record) =>  record.id}
                bordered
                pagination={{ pageSize: pageSize }}
                onChange={onRowChange}
                size="middle"
                mobileBreakPoint={768}
            />
        </>
    )
}

export default DocumentGuideList;